import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { usePagePrefs } from "./PagePrefs";

// Shift+click "favourite" for ANY page toggle with a testId: the pinned option is
// remembered per page and applied once when the page opens.
// Applied once per page visit — a dropdown remounting its options must not re-apply it.
let appliedPath = null;
const appliedKeys = new Set();
export function useAutoPin(id, value, onChange, keys, ready = true) {
    const { pathname } = useLocation();
    const { getPref, setPref } = usePagePrefs();
    const key = id ? `${pathname}:pin:${id}` : null;
    const pinned = key ? getPref("page_toggle", key) || null : null;
    const applied = useRef(false);
    if (appliedPath !== pathname) { appliedPath = pathname; appliedKeys.clear(); }
    useEffect(() => {
        if (applied.current || !ready || !pinned || !onChange) return;
        if (!keys.includes(pinned)) return;
        applied.current = true;
        if (appliedKeys.has(key)) return;
        appliedKeys.add(key);
        if (value !== pinned) onChange(pinned);
    }, [ready, pinned, keys.join("|")]); // eslint-disable-line react-hooks/exhaustive-deps
    const onPin = key ? (k) => setPref("page_toggle", key, pinned === k ? null : k) : null;
    return { pinnedKey: pinned, onPin };
}
